import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useIncomeStatements(id, period) {
  const { data, error, isLoading } = useSWRImmutable(`/react/income_statements/history?stock_id=${id}&period=${period}`, fetcher, { keepPreviousData: true })

  return {
    incomeStatements: data,
    isLoading,
    error
  }
}